import React, {Component} from "react"
import PropTypes from "prop-types"
import {translate} from "react-i18next"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"

import {Col} from "../../../components/Grid"
import ModuleCertificate from "../../../components/ModuleCertificate"
import {dateToString} from "../../../utils"

class ModuleCertificates extends Component {
  static propTypes = {
    modules: PropTypes.array,
    username: PropTypes.string,
    currentLang: PropTypes.string
  }

  static defaultProps = {
    modules: [],
    username: null,
    currentLang: null
  }

  state = {
    currentId: null
  }

  constructor(props) {
    super(props)

    this.closePrintModuleCertificate = this.closePrintModuleCertificate.bind(
      this
    )
  }

  printCertificate(id, filename) {
    const doc = document.getElementById(id)

    setTimeout(function() {
      html2canvas(doc, {
        scale: 2,
        width: 690,
        height: 1120,
        scrollX: 0,
        scrollY: 0
      }).then(canvas => {
        var context = canvas.getContext("2d")
        context.webkitImageSmoothingEnabled = false
        context.mozImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false
        context.scale(2, 2)
        context["imageSmoothingEnabled"] = false
        context["mozImageSmoothingEnabled"] = false
        context["oImageSmoothingEnabled"] = false
        context["webkitImageSmoothingEnabled"] = false
        context["msImageSmoothingEnabled"] = false
        const dataURL = canvas.toDataURL("image/png", 1)
        const pdf = new jsPDF("p", "mm", "a4", true)
        let marginLeft = 13
        let marginRight = 0
        pdf.internal.scaleFactor = 5.7

        pdf.addImage(
          dataURL,
          "PNG",
          marginLeft,
          marginRight,
          "",
          "",
          "",
          "FAST"
        )
        pdf.save(`${filename}.pdf`)
      })
    }, 1000)
  }

  printModuleCertificate(module) {
    this.setState(prevState => {
      return {
        ...prevState,
        currentId: module.id
      }
    })

    const moduleName = module.name.replace(/\s/g, "-").toUpperCase()
    const moduleCompletedDate = dateToString(
      module.completed_date,
      this.props.currentLang
    )

    this.printCertificate(
      `crt-print-module-${module.id}`,
      `MBTML-ZERTIFIKAT-MODUL-${moduleName}-${moduleCompletedDate}`
    )

    setTimeout(this.closePrintModuleCertificate, 3000)
  }

  closePrintModuleCertificate() {
    this.setState(prevState => {
      return {
        ...prevState,
        currentId: null
      }
    })
  }

  renderCompletedModules() {
    const {modules, currentLang} = this.props

    return modules.map(module => {
      return (
        <li key={`module-${module.id}`}>
          <ModuleCertificate
            moduleId={module.id}
            moduleName={module.name}
            articleTitles={module.articles}
            username={this.props.username}
            date={dateToString(module.completed_date, currentLang)}
            isPrinting={this.state.currentId === module.id}
            closePrintDialog={this.closePrintModuleCertificate}
          />
          <span className="date">
            {dateToString(module.completed_date, currentLang)}
          </span>
          <span className="title">
            <span className="topic">{module.topic_name}</span>
            {module.name}
          </span>
          <button
            className="download-button"
            onClick={() => this.printModuleCertificate(module)}
          >
            <i className="icon icon-cert-download" />
          </button>
        </li>
      )
    })
  }

  render() {
    const {t} = this.props

    return (
      <Col lg={8} className="certificates">
        <div className="card">
          <div className="intro-block">
            <h3 className="headline">{t("Meine Modul-Zertifikate")}</h3>
            <p>
              {t(
                "Deine in der Akademie erworbenen Modul-Zertifikate stehen dir hier zum Download bereit."
              )}
            </p>
          </div>
          <div className="info-block">
            <ul>{this.renderCompletedModules()}</ul>
          </div>
        </div>
      </Col>
    )
  }
}

export default translate()(ModuleCertificates)



// WEBPACK FOOTER //
// ./src/containers/UserProfile/ModuleCertificates/index.js